import E from 'wangeditor'
const Public =
{
  //创建富文本编辑器--待定
  createEditor(that)
  {
    const me = this
    let editor = new E('#editor')
    // base64 保存图片
    editor.config.uploadImgShowBase64 = false
    editor.config.customUploadImg = function(resultFiles, insertImgFn)
    {
      me.filesToBase64(resultFiles, that)
    }
    // 关闭粘贴样式的过滤
    editor.config.pasteFilterStyle = false
    // 配置 onchange 回调函数，将数据同步到 vue 中
    editor.config.onchange = (newHtml) =>
    {
      that.form.content = encodeURIComponent(newHtml)
    }
    // 隐藏插入网络图片的功能
    editor.config.showLinkImg = false
    // 限制大小
    // editor.config.uploadImgMaxSize = 12 * 1024 * 1024 // 2M
    // 限制类型
    editor.config.uploadImgAccept = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp']
    // 创建编辑器
    editor.create()
    that.editor = editor
    // 编辑里面赋值 （必须先赋值 that.editor，再写内容）
    if (that.form.content)
      editor.txt.html(me.decodeContent(that.form.content))
  },
  // 安全解码富文本（入库前 encodeURIComponent，回显需解码；兼容多次编码 / 非法 %）
  decodeContent(content)
  {
    if (!content) return content
    let result = content
    for (let i = 0; i < 3; i++)
    {
      if (!/%[\dA-Fa-f]{2}/.test(result)) break
      try
      {
        let next = decodeURIComponent(result)
        if (next === result) break
        result = next
      }
      catch (e)
      {
        try
        {
          let next = decodeURIComponent(result.replace(/%(?![\dA-Fa-f]{2})/g, '%25'))
          if (next === result) break
          result = next
        }
        catch (e2)
        {
          break
        }
      }
    }
    return result
  },

  /**
   * 标题检测
   * @param {String} major 主类型
   * @param {String} minor 子类型
   * @param {String} title 标题
   */
  detection(major, minor, title, that)
  {
    if (title)
    {
      let paras = {
        cmd: 'query',
        _major: major,
        _minor: minor,
        _exp: 'title = ?',
        types: 's',
        vals: title
      }
      window.post.getPost(paras).then((ret) =>
      {
        if (ret.length >= 1)
        {
          that.$message(
            {
              message: '该标题已存在',
              type: 'error',
              customClass: 'mzindex'
            }
          )
        }
        else if (ret.length === 0)
        {
          that.$message(
            {
              message: '该标题可以使用',
              type: 'success',
              customClass: 'mzindex'
            }
          )
        }
      })
    }
  },
  /**
   * 获取下拉框列表
   * @param {String} nodeid  //导航树节点id
   * @param {String} colname  //下拉值所属字段名
   */
  getFldvalue(nodeid, colname)
  {
    let params =
    {
      cmd: 'query',
      _major: 99,
      _minor: 20,
      _exp: `moduleid=${nodeid} and colname='${colname}'`
    }
    return window.post.getPost(params)
  },
  /**
   * 彻底删除--单
   * @param {String} major  //主类型
   * @param {String} minor  //子类型
   */
  deletefn(major, minor, row, that)
  {
    that.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() =>
    {
      let obj = {
        cmd: 'delete',
        _major: major,
        _minor: minor,
        id: row.id
      }
      window.post.getPost(obj).then((ret) =>
      {
        if (ret.ret === 1)
          that.$message({message: '删除失败', type: 'error', customClass: 'mzindex'})
        else
        {
          that.getList()
          that.$message({message: '删除成功', type: 'success', customClass: 'mzindex'})
        }
      })
    }).catch(() =>
    {
      that.$message({message: '已取消删除', type: 'info', customClass: 'mzindex'})
    })
  },
  /**
   * 彻底删除——多
   * @param {String} major  //主类型
   * @param {String} minor  //子类型
   */
  deletesfn(major, minor, that)
  {
    if (!that.multipleSelection)
      that.$message({message: '请先选择要删除的数据', type: 'error', customClass: 'mzindex'})
    else
    {
      that.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() =>
      {
        let obj = {
          cmd: 'deletes',
          _major: major,
          _minor: minor,
          ids: that.multipleSelection.toString()
        }
        window.post.getPost(obj).then((ret) =>
        {
          that.getList()
          that.$message({message: '删除成功', type: 'success', customClass: 'mzindex'})
        })
      }).catch(() =>
      {
        that.$message({message: '已取消删除', type: 'info', customClass: 'mzindex'})
      })
    }
  },
  //获取fld表中的字段数据
  validation(tabname)
  {
    let obj = {
      cmd: 'query',
      _major: 99,
      _minor: 5,
      _exp: `tabname='${tabname}'`
    }
    return Promise.resolve(window.post.getPost(obj))
  },
  //判断是否必填
  isMandatory(fldData, colname)
  {
    if (fldData)
    {
      for (let i = 0; i < fldData.length; i++)
      {
        if (colname === fldData[i].colname && fldData[i].nullable === 0)
          return true
      }
    }
    else
      return false
  },
  //图片上传的URL
  onUploadPicture(that)
  {
    console.log(222)
    let Ip = window.location.hostname
    let UrlType = ''
    if (Ip === 'www.camining.cn')
      UrlType = 'svr/DocSvr'
    else if (Ip === 'camining.cn')
      UrlType = 'svr/DocSvr'
    else
      UrlType = 'svr/DocSvr'
    let data = {
      cmd: 'upload',
      major: 11,
      minor: 1,
      entityid: 1,
      username: 'name',
      fid: 1,
      sys: 11,
      task: '',
      dir: '',
      glid: '0',
      _auth: cx.http.getAuth()
    }
    let params = {
      url: UrlType,
      title: '',
      tip: '',
      data: data
    }
    that.url = `${params.url}?cmd=${data.cmd}&major=${data.major}&minor=${data.minor}&username=admin&fid=11&sys=11&dir=${params.title}&entityid=1&glid=0&task=Dmky&_auth=${cx.http.getAuth()}`
  },
  //文件上传的URL
  onUploadFile(that)
  {
    let Ip = window.location.hostname
    let UrlType = ''
    if (Ip === 'www.camining.cn')
      UrlType = 'svr/DocSvr'
    else if (Ip === 'camining.cn')
      UrlType = 'svr/DocSvr'
    else
      UrlType = 'svr/DocSvr'
    let data = {
      cmd: 'upload',
      major: 11,
      minor: 1,
      entityid: 1,
      username: 'name',
      fid: 1,
      sys: 11,
      task: '',
      dir: '',
      glid: '0',
      _auth: cx.http.getAuth()
    }
    let params = {
      url: UrlType,
      title: '',
      tip: '',
      data: data
    }
    that.url = `${params.url}?cmd=${data.cmd}&major=${data.major}&minor=${data.minor}&username=admin&fid=11&sys=11&dir=${params.title}&entityid=1&glid=0&task=Dmky&_auth=${cx.http.getAuth()}`
  },
  //视频上传的URL
  onUploadVideo(that)
  {
    let Ip = window.location.hostname
    let UrlType = ''
    if (Ip === '127.0.0.1')
      UrlType = 'svr/DocSvr'
    else if (Ip === 'localhost')
      UrlType = 'svr/DocSvr'
    else
      UrlType = 'svr/DocSvr'
    let data = {
      cmd: 'upload',
      major: 11,
      minor: 1,
      entityid: 1,
      username: 'name',
      fid: 1,
      sys: 11,
      task: '',
      dir: '',
      glid: '0',
      _auth: cx.http.getAuth()
    }
    let params = {
      url: UrlType,
      title: '',
      tip: '',
      data: data
    }
    that.url = `${params.url}?cmd=${data.cmd}&major=${data.major}&minor=${data.minor}&username=admin&fid=11&sys=11&dir=${params.title}&entityid=1&glid=0&task=Dmky&_auth=${cx.http.getAuth()}`
  },
  //图片上传之前的钩子
  beforeUploadPicture(file, that)
  {
    const isJPG = file.type === 'image/jpeg'
    const isPNG = file.type === 'image/png'
    const isLt10M = file.size / 1024 / 1024 < 10
    if ((isJPG || isPNG) && isLt10M)
      return true
    else
    {
      that.$message({message: '上传图片只能是 JPG 或者 PNG 格式且图片大小不能超过 5MB!', type: 'error', customClass: 'mzindex'})
      return false
    }
  },
  //文件上传之前的钩子
  beforeUploadFile(file, that)
  {
    const isPDF = file.type === 'application/pdf'
    if (isPDF)
      return true
    else
    {
      that.$message({message: '上传文件只能是 PDF 格式!', type: 'error', customClass: 'mzindex'})
      return false
    }
    // return true
  },
  //视频上传之前的钩子
  beforeUploadVideo(file, that)
  {
    const isMP4 = file.type === 'video/mp4'
    if (isMP4)
      return true
    else
    {
      that.$message({message: '上传视频只能是 MP4 格式!', type: 'error', customClass: 'mzindex'})
      return false
    }
  },
  //上传中的钩子
  handlePictureCardPreview(file, that)
  {
    that.dialogImageUrl = file.url
    that.dialogVisible = true
  },
  //上传中的钩子2
  handlePictureCardPreview2(file, that)
  {
    that.dialogImageUrl2 = file.url
    that.dialogVisible2 = true
  },
  //图片上传成功
  onSuccess(response, that)
  {
    let Ip = window.location.hostname
    let prefix = ''
    if (Ip === 'www.camining.cn')
      prefix = 'http://www.camining.cn/uploadfile/'
    else if (Ip === 'camining.cn')
      prefix = 'http://www.camining.cn/uploadfile/'
    else
      prefix = 'http://192.168.2.201:8083/gisdm/uploadfile/'
    that.form.thumb = `${prefix}${response[0].filename}`
  },
  //图片上传成功2
  onSuccess1(response, that)
  {
    let Ip = window.location.hostname
    let prefix = ''
    if (Ip === 'www.camining.cn')
      prefix = 'http://www.camining.cn/uploadfile/'
    else if (Ip === 'camining.cn')
      prefix = 'http://www.camining.cn/uploadfile/'
    else
      prefix = 'http://192.168.2.201:8083/gisdm/uploadfile/'
    that.form.thumb2 = `${prefix}${response[0].filename}`
  },
  //pdf文件上载成功
  onFileSuccess(response, that)
  {
    let Ip = window.location.hostname
    let prefix = ''
    if (Ip === 'www.camining.cn')
      prefix = 'http://www.camining.cn/uploadfile/'
    else if (Ip === 'camining.cn')
      prefix = 'http://www.camining.cn/uploadfile/'
    else
      prefix = 'http://192.168.2.201:8083/gisdm/uploadfile/'
    that.form.pdf = `${prefix}${response[0].filename}`
  },
  //视频上传成功
  onVideoSuccess(response, that)
  {
    let Ip = window.location.hostname
    let prefix = ''
    if (Ip === 'www.camining.cn')
      prefix = 'http://www.camining.cn/uploadfile/'
    else if (Ip === 'camining.cn')
      prefix = 'http://www.camining.cn/uploadfile/'
    else
      prefix = 'http://192.168.2.201:8083/gisdm/uploadfile/'
    that.form.video = `${prefix}${response[0].filename}`
  },
  //上传发生变化（上传或者删除）
  handleEditChange(file, fileList, that)
  {
    if (fileList.length >= 1)
      that.hideUploadEdit = true
  },
  //删除图片
  handleRemovePicture(fileList, that)
  {
    if (fileList.name)
    {
      const isjpg = fileList.name.split('.')[1] === 'jpg'
      const ispng = fileList.name.split('.')[1] === 'png'
      const isLt2M = fileList.size / 1024 / 1024 < 10
      if ((isjpg || ispng) && isLt2M)
      {
        that.form.thumb = ''
        that.hideUploadEdit = false
        return true
      }
    }
  },
  //删除文件
  handleRemoveFile(fileList, that)
  {
    const ispdf = fileList.name.split('.')[1] === 'pdf'
    if (ispdf)
    {
      that.form.pdf = ''
      that.hideUploadEdit = false
      return true
    }
  },
  //删除视频
  handleRemoveVideo(fileList, that)
  {
    const ismp4 = fileList.name.split('.')[1] === 'mp4'
    if (ismp4)
    {
      that.form.video = ''
      that.hideUploadEdit = false
      return true
    }
  },
  //父组件新增添加Tabs
  addTab(that)
  {
    that.editableTabs.push(that.addobj)
    that.editableTabsValue = that.addobj.name
  },
  //删除Tabs
  removeTab(targetName, that)
  {
    let tabs = that.editableTabs
    let activeName = that.editableTabsValue
    if (activeName === targetName)
    {
      tabs.forEach((tab, index) =>
      {
        if (tab.name === targetName)
        {
          let nextTab = tabs[index + 1] || tabs[index - 1]
          if (nextTab)
            activeName = nextTab.name
        }
      })
    }
    that.editableTabsValue = activeName
    that.editableTabs = tabs.filter(tab => tab.name !== targetName)
    that.editableTabsValue = '1'
  },
  //重置搜索条件
  cancelfnBtn(srt, that)
  {
    for (let key in that.form)
    {
      if (key === srt) continue
      that.form[key] = ''
    }
    that.getList()
  },
  // 用户设备的判断
  isMobile()
  {
    let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
    return flag
  }
}
export default Public



// WEBPACK FOOTER //
// ./src/Public.js